export const ITEM_WIDTH = 40;
export const MAX_ITEMS = 7;
export const PAGE_SIZES = [10, 25, 50, 100];